import { render } from "./tTools.vue?vue&type=template&id=1a99bc3c&scoped=true"
import script from "./tTools.vue?vue&type=script&lang=js"
export * from "./tTools.vue?vue&type=script&lang=js"

import "./tTools.vue?vue&type=style&index=0&id=1a99bc3c&lang=less&scoped=true"

import exportComponent from "D:\\huiwu\\wgt_user_web_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a99bc3c"]])

export default __exports__